export default __webpack_public_path__ + "d42d734ed93ef36b261ab2530993b432.svg";